(() => {
  const calculateTotal = (base, selected, quantity) => (Number(base) + selected.reduce((sum, item) => sum + Number(item.price), 0)) * Number(quantity);
  if (typeof module !== 'undefined' && module.exports) { module.exports = { calculateTotal }; return; }
  if (customElements.get('sp-product-addons')) return;
  class ProductAddons extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.section = this.closest('[id^="MainProduct-"]');
      this.form = document.getElementById(this.dataset.parentFormId);
      this.quantity = this.form?.querySelector('[name="quantity"]');
      this.onOptionClick = event => {
        const option = event.target.closest('[data-sp-addon]');
        if (!option || option.disabled) return;
        const selected = option.getAttribute('aria-checked') !== 'true';
        option.setAttribute('aria-checked', String(selected));
        option.classList.toggle('is-selected', selected);
        const icon = option.querySelector('[data-sp-addon-icon]');
        if (icon) icon.textContent = selected ? '✓' : '+';
        this.updateTotal();
      };
      this.addEventListener('click', this.onOptionClick);
      this.change = () => this.updateTotal();
      this.form?.addEventListener('change', this.change);
      this.form?.addEventListener('input', this.change);
      this.track = this.querySelector('[data-sp-addon-track]');
      this.previous = this.querySelector('[data-sp-addon-prev]');
      this.next = this.querySelector('[data-sp-addon-next]');
      this.navigate = event => {
        const direction = event.target.closest('[data-sp-addon-next]') ? 1 : event.target.closest('[data-sp-addon-prev]') ? -1 : 0;
        if (!direction || !this.track) return;
        const card = this.track.querySelector('[data-sp-addon]');
        const step = (card?.getBoundingClientRect().width || this.track.clientWidth) + 12;
        this.track.scrollBy({ left: direction * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.addEventListener('click', this.navigate);
      this.syncNavigation = () => {
        if (!this.track) return;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.track?.addEventListener('scroll', this.syncNavigation, { passive: true });
      this.resizeObserver = new ResizeObserver(this.syncNavigation);
      if (this.track) this.resizeObserver.observe(this.track);
      requestAnimationFrame(this.syncNavigation);
      this.updateTotal();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.change);
      this.form?.removeEventListener('input', this.change);
      this.track?.removeEventListener('scroll', this.syncNavigation);
      this.removeEventListener('click', this.navigate);
      this.removeEventListener('click', this.onOptionClick);
      this.resizeObserver?.disconnect();
      this.ready = false;
    }
    updateTotal() {
      const selected = [...this.querySelectorAll('[data-sp-addon][aria-checked="true"]')];
      const quantity = Math.max(1, Number(this.quantity?.value || 1));
      const total = calculateTotal(this.dataset.basePrice, selected.map(option => ({ price: option.dataset.price })), quantity);
      const currency = this.dataset.currency || 'USD';
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(total / 100);
      this.section?.querySelectorAll('.product-form__submit [data-product-submit-price]').forEach(label => { label.textContent = formatted; });
    }
  }
  customElements.define('sp-product-addons', ProductAddons);
})();
